import {
    SET_SCANNED_ID,
    SET_TAKEN_PHOTO,
    SET_VERIFICATION,
} from '../../../constants/ActionTypes';
import applicantIdVerificationInitialState from './applicantIdVerificationInitialState';

function applicantIdVerificationReducer(state = applicantIdVerificationInitialState, action) {
    switch (action.type) {
    case SET_SCANNED_ID: {
        return {
            ...state,
            scannedId: action.scannedId,
        };
    }
    case SET_TAKEN_PHOTO: {
        return {
            ...state,
            takenPhoto: action.takenPhoto,
        };
    }
    case SET_VERIFICATION: {
        return {
            ...state,
            verified: action.verification,
        };
    }
    default:
        return state;
    }
}

export default applicantIdVerificationReducer;



// WEBPACK FOOTER //
// ./src/app/FormStepper/ApplicantIdVerification/applicantIdVerificationReducer.js